import moment from 'moment-timezone';
import { crowdLevelForRate } from '../data/crowdLevels';

export const FRESHNESS_THRESHOLD_MINUTES = 8;
const MIN_FRESH_CARS_FOR_AVERAGE = 3;

// 計測時刻が現在時刻から8分以上前でないかを判定する
export function isFreshCongestion(measuredDateTime, now = moment.tz('Asia/Tokyo')) {
  return now.diff(moment(measuredDateTime), 'minutes') < FRESHNESS_THRESHOLD_MINUTES;
}

// 鮮度チェックを通過した号車のみを返す
export function freshCongestionCars(congestionCars, now = moment.tz('Asia/Tokyo')) {
  return (congestionCars || []).filter(car => isFreshCongestion(car.measuredDateTime, now));
}

// 車両全体の平均乗車率。取得できた(鮮度チェックを通過した)号車数で割る。
// 有効な号車が3両以下なら null を返す(呼び出し側で代替文言を出す)。
export function averageCongestionRate(congestionCars, now = moment.tz('Asia/Tokyo')) {
  const freshCars = freshCongestionCars(congestionCars, now);

  if (freshCars.length <= MIN_FRESH_CARS_FOR_AVERAGE) {
    return null;
  }

  const sum = freshCars.reduce((total, car) => total + car.congestion_rate, 0);
  return sum / freshCars.length;
}

// 車両全体の平均混雑度レベル(アイコン・ラベル付き)。表示できない場合は null。
export function averageCrowdLevel(congestionCars, now = moment.tz('Asia/Tokyo')) {
  const rate = averageCongestionRate(congestionCars, now);

  if (rate === null) {
    return null;
  }

  return crowdLevelForRate(Math.round(rate));
}
